var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseWarning',[_c('i18n',{attrs:{"path":"warnings.noSuitablePartnership.baseWarning","tag":"span"},scopedSlots:_vm._u([{key:"inPitchArea",fn:function(){return [_c('a',{attrs:{"href":_vm.infoURLs[_vm.data.pitchArea],"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.pitchArea)+" ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }